import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import AdviceSection from '../common/AdviceSection';
import SelectFilters from '../common/select-filters/SelectFilters';
import Cards from '../common/cards/Cards';
import Pagination from '../common/pagination/Pagination';
import Methodology from '../common/Methodology';

import { getOSHCountries, getOSHData } from '../../api';

const OSHStatistics = props => {

	const [countries, setCountries] = useState([]);
	const [matrixPageData, setMatrixPageData] = useState([]);
	const [pageOfItems, setPageOfItems] = useState([]);
	const [isFetching, setIsFetching] = useState(true);
	const [defaultTags, setDefaultTags] = useState(false);
	const [filters, setFilters] = useState({
		countries: [],
		checks: [],
		searchBar: ''
	})

	useEffect(() => {
		// Update the title of the page
		document.title = props.literals.L22018 +  " - " + props.literals.L22020 + " - " + props.literals.L363;

		try {
			getOSHCountries('MATRIX_STATISTICS' ,['UK'])
			.then((res) => {
				setCountries(res.resultset);
			});
			
			if (!props.lockedCountry || (props.lockedCountry == "CH" || props.lockedCountry == "IS" || props.lockedCountry == "LU" || props.lockedCountry == "NO")) {
				getOSHData('MATRIX_STATISTICS')
				.then((res) => {
					setMatrixPageData(res.resultset);
				});
			} else {
				getOSHData('MATRIX_STATISTICS', { countries: [ props.lockedCountry ] } )
				.then((res) => {
					// Filter the returned elements so there are no elements with empty values for all the texts
					setMatrixPageData( res.resultset.filter(item => props.literals['L'+item.text1] != "" 
					|| props.literals['L'+item.text2] != "" || props.literals['L'+item.text3] != "") );
				});
			}
		} catch(error) {
			console.log('Error getting data: ', error)
		} finally {
			setIsFetching(false);
		}
	}, [])

	useEffect(() => {
		setIsFetching(true);
		try {
			getOSHData('MATRIX_STATISTICS', filters)
			.then((res) => {
				// Filter the returned elements so there are no elements with empty values for all the texts
				setMatrixPageData( res.resultset.filter(item => props.literals['L'+item.text1] != "" 
				|| props.literals['L'+item.text2] != "" || props.literals['L'+item.text3] != "") );
			})
		} catch (error) {
			console.log('Error Fetching data', error)
		} finally {
			setIsFetching(false);
		}
	}, [filters])

	useEffect(() => {
		const countryDefault = countries.find((country) => country.code == props.lockedCountry);
		if(countryDefault && props.lockedCountry != "CH" && props.lockedCountry != "IS" && props.lockedCountry != "LU" && props.lockedCountry != "NO"){
			setDefaultTags(true);
			setFilters( {...filters, countries: [countryDefault] } );
		}
	}, [countries, defaultTags])

	useEffect(() => {
		if (props.selectedByUser && countries.length > 0)
		{
			let countryDefault = countries.find((country) => country.code == props.lockedCountry);
			if(props.lockedCountry != "CH" && props.lockedCountry != "IS" && props.lockedCountry != "LU" && props.lockedCountry != "NO")
			{
				setFilters( {...filters, countries: [countryDefault] } );
			}
		}
	}, [countries, props.lockedCountry])

	const handleCallbackCountry = (countryCallback) => {
		const countryFilter = filters.countries;
		const countryCode = filters.countries.find((country) => country.code == countryCallback.code)
		if (countryCallback.code != countryCode?.code) 
		{
			setFilters( {...filters, countries: [...countryFilter, countryCallback ] } );
		} 
		else 
		{
			const index = filters.countries.findIndex((country) => country.code == countryCallback.code);
			const newCountryFilters = filters.countries;
			newCountryFilters.splice(index, 1);
			setFilters( {...filters, countries: newCountryFilters } );
		}
	}

	const handleCallbackCategory = (categoryCallback) => {
		const checkFilter = filters.checks.find((data) => data.id == categoryCallback.id);
		const checks = filters.checks;
		if (!checkFilter) 
		{
			setFilters( {...filters, checks: [...checks, {...categoryCallback, check: true } ] } );
		} 
		else 
		{
			const index = filters.checks.findIndex((data) => data.id == categoryCallback.id);
			const newArray = filters.checks;
			newArray.splice(index, 1);
			setFilters( {...filters, checks: newArray } );
		}
	}

	// Handles callback for the search bar on filters component
	const handleCallbackSearch = (searchCallback) => {
		setFilters( {...filters, searchBar: searchCallback } );
	}

	//when country is selected
	const onSelectCountryTag = (countryCode) => {
		return () => {
			const countryIndex = filters.countries.findIndex((country) => country.code == countryCode);
			const newArray = filters.countries;
			newArray.splice(countryIndex, 1);
			setFilters( {...filters, countries: newArray } );
		}
	}

	//whe category is selected
	const onSelectInstitutionTag = (institutionId) => {
		return () => {
			const institutionIndex = filters.checks.findIndex((institution) => institution.id == institutionId);
			const newArray = filters.checks;
			newArray.splice(institutionIndex, 1);
			setFilters( {...filters, checks: newArray } );
		}
	}

	// Handles change of page when clicked on the next or prev
	const onChangePage = (pageOfItems) => {
		setPageOfItems(pageOfItems);
	}

	return(
		<div>
			<AdviceSection literals={ props.literals } section={["osh-infrastructure","osh-statistics"]} methodologyData={{section: 'osh-infrastructure', subsection: 'OSH statistics, surveys and research', indicator: 80}} />

			<section className="container">

				<SelectFilters 
					selectCountries={ countries }
					literals={ props.literals }
					onClickCountry={ handleCallbackCountry }
					onClickInstitution={ handleCallbackCategory }
					onSearchbarClick={ handleCallbackSearch }
					selectedFilters={ filters }
					filterCategory={ 'category' }
				/>

				<div className="container">
					<div className="selected--tags-wrapper">
						{ filters && (
							<div>
								{ filters.countries.map((country) => (
									<span key={country.code} className="selected-tag" onClick={ onSelectCountryTag(country.code)}>{country.code == 'EU28' ? '' : `(${country.code})` } {country.name}</span>
								))}
								{ filters.checks.map((category) => {
									if (category.check) {
										return <span key={category.id} className="selected-tag" onClick={ onSelectInstitutionTag(category.id)} >{props.literals[`L${category.literal}`] }</span>
									}
								})}
							</div>
						)}
					</div>
					
				{/** Cards Component */}
				<div className="matrix--elements--wrapper">
					{ pageOfItems.length > 0 ? (
						pageOfItems.map((data, index) => {
							const position = matrixPageData.findIndex((matrixData) => matrixData == data);
							const id = `${index}-${data.country.code}-${position}`
							return <Cards key={ id } idCard={ id } countryData={ data } literals={ props.literals } cardType={ 'statistics' } />
						})
					) : (<span>{props.literals.L20706}</span>)}
				</div>
					
				{/* PAGINATION */}
				<Pagination items={ matrixPageData } onChangePage={ onChangePage } />

				</div>
			</section>

			<Methodology literals={ props.literals } section={'OSH statistics, surveys and research'} />
		</div>
	)
}
OSHStatistics.displayName = 'OSHStatistics';

function mapStateToProps(state){
	const { lockedCountry, selectedByUser } = state.selectCountries;
    return { lockedCountry, selectedByUser };
}

export default connect(mapStateToProps, null )(OSHStatistics);